export default "__VITE_PUBLIC_ASSET__9fa4e041__"